import { useEffect, useRef, useState } from 'react';
import CircleButton from '../CircleButton';
import { useTranslate } from '@hmpu/powerups.intl.legacy.hooks.use-translate';
import { useStore } from '@hmpu/powerups.store';
import GAME_PAGES from '../../constants/GAME_PAGES';

export const PauseButton = (props) => {
  const translate = useTranslate();
  const isPlaying = useStore((state) => state.isPlaying);
  const play = useStore((state) => state.play);
  const setPlay = useStore((state) => state.setPlay);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const setIsPauseEnabled = useStore((state) => state.setIsPauseEnabled);
  const page = useStore((state) => state.currentPage);
  const [isInFocus, setIsInFocus] = useState(false);
  const pauseBtn = useRef();
  const showPauseBtnForPC = useStore((state) => state.showPauseBtnForPC);
  const componentKey = useStore((state) => state.movesCount);
  const currentCueMetadata = useStore((state) => state.currentCueMetadata);
  const [hidePauseBtnAtAll, setHidePauseBtnAtAll] = useState(false);

  const styles = {
    // height: '8vmax',
    // width: '8vmax',
    zIndex: '90',
    padding: 0,
    display: 'block',
  };

   useEffect(() => {
      if(!(page === GAME_PAGES.GAME_PLAY)) {
        setHidePauseBtnAtAll(
          currentCueMetadata?.id === "END_LOOP" 
          || currentCueMetadata?.id === "CHAPTER_HOLD"
          );
      } else {
        if(currentCueMetadata?.id.includes("COMPLETION")) {
          setHidePauseBtnAtAll(true)
        } else if(currentCueMetadata?.id.includes("TRANSITION") || 
        currentCueMetadata?.id.includes("TRIGGER_TEXT") || 
        currentCueMetadata?.id.includes("COUNTDOWN") || 
        currentCueMetadata?.id.includes("INTRO") || 
        currentCueMetadata?.id.includes("HIT")) {
          setHidePauseBtnAtAll(false);
        }
      }
  }, [currentCueMetadata, page])




  useEffect(() => {
    if (!isPauseEnabled && !isPlaying && isInFocus)
      document.querySelector('.vie-button')?.focus(); // move focus to the first emerging VIE button when pause button disappears
  }, [isPauseEnabled, isPlaying, isInFocus]);

  return (
    (((page === GAME_PAGES.SPLASH )
      || page === GAME_PAGES.ONBOARDING
      || page === GAME_PAGES.GAME_PLAY)
      && !hidePauseBtnAtAll
      && componentKey !== 2) ?
    /*(isPauseEnabled || isPlaying) &&*/ (
      <CircleButton
        variant="dark"
        ref={pauseBtn}
        onFocus={() => {
          setIsInFocus(true);
        }}
        onBlur={() => {
          setIsInFocus(false);
        }}
        icon={!isPauseEnabled ? 'pause' : 'play'}
        style={styles}
        ariaLabel={
          translate(!isPauseEnabled ? 'pauseButton' : 'resumeButton', 'GENERAL')
            .ariaLabel
        }
        onClick={() => {
          setIsPauseEnabled(true);
          // set to true when video is paused
          setPlay(!play);
        }}
      />
    ) : null
  );
};

export default PauseButton;
